function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useColumnScroll } from '../../hooks/table';
import React, { useEffect, useRef } from 'react';
import { usePrefixCls } from '@byte-design/config';
export function TableScrollerColumn(props) {
  var width = props.width,
      scrollerWidth = props.scrollerWidth,
      fixedLeftWidth = props.fixedLeftWidth,
      fixedRightWidth = props.fixedRightWidth,
      height = props.height,
      children = props.children;
  var ref = useRef(null);

  var _useColumnScroll = useColumnScroll(function (s) {
    if (ref.current) {
      ref.current.scrollLeft = s;
    }
  }),
      _useColumnScroll2 = _slicedToArray(_useColumnScroll, 2),
      scroll = _useColumnScroll2[0],
      onMoveScroll = _useColumnScroll2[1];

  useEffect(function () {
    if (ref.current && ref.current.scrollLeft !== scroll) {
      ref.current.scrollLeft = scroll;
    }
  });
  var cls = usePrefixCls('table-column-visible');
  var scrollerCls = usePrefixCls('table-column-scroller');

  var onScroll = function onScroll(e) {
    if (e.currentTarget !== e.target) {
      return;
    }

    onMoveScroll(e.target.scrollLeft);
  };

  return React.createElement("div", {
    ref: ref,
    className: cls,
    onScroll: onScroll,
    style: {
      width: "".concat(width, "px"),
      height: "".concat(height, "px")
    }
  }, React.createElement("div", {
    className: scrollerCls,
    style: {
      paddingLeft: "".concat(fixedLeftWidth, "px"),
      paddingRight: "".concat(fixedRightWidth, "px"),
      width: "".concat(scrollerWidth + fixedLeftWidth + fixedRightWidth, "px"),
      height: "".concat(height, "px")
    }
  }, children));
}